(function (angular, app) {
   "use strict";

    angular.module(app.modules.common.name)
      .constant(app.modules.common.constants.appmessaging,
         {
            api : {
               error : "There was an error connecting to the GG API"
               , badresponse : "The GG API Response was invalid."
            }
            , processing : "Processing..."
            , loginrequest : {
               success : "You have successfully logged in."
               , fail : "Your login attempt has failed.  Try again."
            }
            , passwordrequest : {
               success : "A new password has been sent to the email address you provided."
               , fail : "The password request has failed.  Try again."
            }
            , registrationrequest : {
               success : "You have successfully registered."
               , fail : "Your attempt to register has failed.  Try again."
            }
            , course : {
               search : {
                   noresults : "There were no courses found matching the request."
                  , nosearchresults : "There are no courses that matched your search criteria."
                  , nogpsresults : "There are no courses near your current location."
                  , nomyresults : "There are no courses in your saved courses."
                  , noteeresults : "There were no tees found matching the request."
               }
            }
            , group : {
               search : {
                   noresults : "There were no groups found matching the request."
                  , nosearchresults : "There are no groups that matched your search criteria."
                  , nogpsresults : "There are no groups near your current location."
                  , nomyresults : "There are no groups in your saved courses."
               }
            }
            , member : {
               search : {
                   noresults : "There were no players found matching the request."
                  , nosearchresults : "There are no players that matched your search criteria."
                  , nogpsresults : "There are no players near your current location."
                  , nomyresults : "There are no players in your saved list."
               }
                , profile: {
                    success : "Your profile has been updated."
                }
            }
         }
      );
}(angular, app));
